import { dayjs } from 'src/lib/dayjs'

import { IFolder } from './types'

export function getFolderName(folder?: IFolder): string {
  if (folder?.name) {
    return folder.name
  } else {
    return 'the folder'
  }
}

export function getUpdatedAtString(folder: IFolder): string {
  const currentYear = dayjs().year()
  const updatedAt = dayjs(folder.updated_at)
  const formatString = updatedAt.year() === currentYear ? 'MMM D' : 'MMM D, YYYY'
  return updatedAt.format(formatString)
}
